module.exports = __webpack_public_path__ + "03_mid_grey.e09f4aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_mid_grey.png
// module id = Rjdx
// module chunks = 0